import { cn } from '@/lib/cn';

interface SkeletonProps {
  className?: string;
  variant?: 'line' | 'card' | 'tableRow';
}

function SkeletonBase({ className }: { className?: string }) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-bg-elevated', className)}
      role="status"
      aria-label="Loading"
    />
  );
}

export function Skeleton({ variant = 'line', className }: SkeletonProps) {
  switch (variant) {
    case 'card':
      return (
        <div className={cn('space-y-3 rounded-lg border border-border-default bg-bg-secondary p-6', className)}>
          <SkeletonBase className="h-5 w-1/3" />
          <SkeletonBase className="h-4 w-full" />
          <SkeletonBase className="h-4 w-2/3" />
        </div>
      );
    case 'tableRow':
      return (
        <div className={cn('flex items-center gap-4 py-3', className)}>
          <SkeletonBase className="h-4 w-1/4" />
          <SkeletonBase className="h-4 w-1/3" />
          <SkeletonBase className="h-4 w-1/6" />
          <SkeletonBase className="h-4 w-1/5" />
        </div>
      );
    default:
      return <SkeletonBase className={cn('h-4 w-full', className)} />;
  }
}

export function SkeletonList({ count = 5, variant = 'line' }: { count?: number; variant?: SkeletonProps['variant'] }) {
  return (
    <div className="space-y-3">
      {Array.from({ length: count }, (_, i) => (
        <Skeleton key={i} variant={variant} />
      ))}
    </div>
  );
}
